import { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { graphql, createRefetchContainer } from 'react-relay/legacy.js';
import {
    RecentlyViewedItemsProvider,
    TABLET,
    DESKTOP,
} from 'dibs-recent-history/exports/RecentlyViewedItemsProvider.ts';
import { ServerVarsContext } from '../global/ServerVarsContext/ServerVarsContext.tsx';

// components
import { PdpRespCondensedContainer } from './PdpRespCondensedContainer/PdpRespCondensedContainer.tsx';
import { PdpSharedLayout } from './PdpSharedLayout.jsx';

export class PdpRespCondensedLayoutComponent extends Component {
    constructor(props) {
        super(props);

        this.getAdditionalTrackingData = this.getAdditionalTrackingData.bind(this);
    }

    getAdditionalTrackingData() {
        return {
            pageType: 'Products',
            isCondensed: 'Y',
        };
    }

    render() {
        const { isTablet } = this.context || {};
        const viewer = this.props?.viewer || null;
        const user = viewer?.user || null;
        const item = viewer?.itemRead?.[0] || null;
        const similarLandingItems = viewer.similarLandingItems || null;

        return (
            <PdpSharedLayout
                user={user}
                viewer={viewer}
                additionalTrackingData={this.getAdditionalTrackingData()}
                doRefetch={this.props.relay.refetch}
            >
                {({ pdpHead, currency, selectedSkuId }) => (
                    <>
                        <Helmet {...pdpHead.getCondensedPdpData()} />
                        <RecentlyViewedItemsProvider
                            excludedItemIds={item?.serviceId ? [item?.serviceId] : null}
                            deviceType={isTablet ? TABLET : DESKTOP}
                        >
                            <PdpRespCondensedContainer
                                currency={currency}
                                selectedSkuId={selectedSkuId}
                                user={user}
                                item={item}
                                viewer={viewer}
                                similarLandingItems={similarLandingItems}
                            />
                        </RecentlyViewedItemsProvider>
                    </>
                )}
            </PdpSharedLayout>
        );
    }
}

PdpRespCondensedLayoutComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
};

PdpRespCondensedLayoutComponent.contextType = ServerVarsContext;

export const PdpRespCondensedLayout = createRefetchContainer(
    PdpRespCondensedLayoutComponent,
    {
        viewer: graphql`
            fragment PdpRespCondensedLayout_viewer on Viewer {
                ...PdpRespCondensedContainer_viewer
                ...PdpSharedLayout_viewer
                user(userId: $userId) @include(if: $fetchUser) {
                    ...PdpRespCondensedContainer_user
                    ...PdpSharedLayout_user
                }
                itemRead(itemIds: $itemIds) {
                    ... on Item {
                        serviceId
                        ...PdpRespCondensedContainer_item
                    }
                }
                similarLandingItems: moreLikeThisItem(
                    first: 12
                    itemId: $itemId
                    isTrade: $isTrade
                    useML: true
                ) @include(if: $fetchPdp) {
                    ...PdpRespCondensedContainer_similarLandingItems
                }
            }
        `,
    },
    graphql`
        query PdpRespCondensedLayoutRefetchQuery(
            $isClient: Boolean!
            $afterDisplayOrBtSsr: Boolean!
            $afterDisplay: Boolean!
            $itemId: String!
            $itemIds: [String]!
            $userId: String = ""
            $guestId: String = ""
            $userIds: [String]
            $fetchUser: Boolean!
            $isTrade: Boolean!
            $isMultiSku: Boolean = false
            $followSearchPages: [String]
            $followSearchTypes: [types] = [SEARCH, USER_PREFERENCE]
            $fetchPdp: Boolean!
            $forcedCurrency: Currency
            $localRecentHistoryItemIds: [String] = []
            $fetchUserRecentHistoryItem: Boolean = false
            $userCountryCode: String = ""
            $priceBookName: String = ""
            $isInteractivePdpChat: Boolean = false
            $fetchRegionalInfo: Boolean = false
            $userZipCode: String!
            $afterDisplayAndBtNone: Boolean!
            $numOfSponsoredItems: Int = 10
            $maxSponsoredItems: Int
            $minSponsoredItemsSteps: [Int!] = [5]
        ) {
            viewer {
                ...PdpRespCondensedLayout_viewer
            }
        }
    `
);
